import { render, staticRenderFns } from "./RelatorioOfertasGlobais.vue?vue&type=template&id=1bd7e3fc"
import script from "./RelatorioOfertasGlobais.vue?vue&type=script&lang=js"
export * from "./RelatorioOfertasGlobais.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dartanghanvani/Documents/workspace/recuperi-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bd7e3fc')) {
      api.createRecord('1bd7e3fc', component.options)
    } else {
      api.reload('1bd7e3fc', component.options)
    }
    module.hot.accept("./RelatorioOfertasGlobais.vue?vue&type=template&id=1bd7e3fc", function () {
      api.rerender('1bd7e3fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/RelatorioOfertasGlobais.vue"
export default component.exports